module.exports = __webpack_public_path__ + "img/informe_federal_indicador14.86ade03c.svg";